import script from "./Invoicings.vue?vue&type=script&setup=true&lang=js"
export * from "./Invoicings.vue?vue&type=script&setup=true&lang=js"

import "./Invoicings.vue?vue&type=style&index=0&id=381bbfb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381bbfb4"]])

export default __exports__